import { Component } from "react";
import { format } from "date-fns";

class DateUtilities extends Component {
    formattedDate = (timeStamp, resultFormat) => (timeStamp ? format(new Date(timeStamp), resultFormat) : "");

    timestampToIst = (timestamp) => {
        const istOffset = 330;
        const date = new Date(timestamp);
        const utcDate = new Date(date.toUTCString());
        const istDate = new Date(utcDate.getTime() + (istOffset * 60 * 1000));
        return istDate.getTime();
    }
  
    formatTimeStamp = (timestamp) => {
        const date = new Date(timestamp);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        // format(new Date(timestamp), "HH/mm")
        return `${hours}:${minutes}`;
    };    
}

const dateUtilities = new DateUtilities();

export default dateUtilities;
